"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.homePageRoutes = exports.checkForVerifyEmailParam = exports.checkForVerifyDeviceParam = exports.checkForVerifyAddressParam = exports.checkForResetPassParam = exports.checkForLoginParam = exports.checkForDepositConfirmationParam = exports.checkForConfirmWithdrawParam = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _path = _interopRequireDefault(require("./path"));
var _config = _interopRequireDefault(require("../config"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var checkForLoginParam = exports.checkForLoginParam = function checkForLoginParam() {
  var forceLogIn = _config["default"].LandingPage.forceLogIn;
  if (forceLogIn && checkForConfigLinks()) return false;
  if (window.location.href.includes(forceLogIn ? '' : 'login')) return true;
  return false;
};
var checkForConfigLinks = function checkForConfigLinks() {
  var hasLinks = false;
  var checkURL = [_config["default"].documentationLink, _config["default"].SignupForm.termsAndServicesLink, _config["default"].SignupForm.privacyPolicyLink];
  for (var urlNum = 0; urlNum < checkURL.length; urlNum++) {
    if (checkURL[urlNum] !== '/' && window.location.href.includes(checkURL[urlNum])) {
      hasLinks = true;
    }
  }
  return hasLinks;
};
var checkForVerifyEmailParam = exports.checkForVerifyEmailParam = function checkForVerifyEmailParam() {
  if (window.location.href.includes('verifyEmail')) return true;
  return false;
};
var checkForConfirmWithdrawParam = exports.checkForConfirmWithdrawParam = function checkForConfirmWithdrawParam() {
  if (window.location.href.includes('confirmWithdraw')) return true;
  return false;
};
var checkForResetPassParam = exports.checkForResetPassParam = function checkForResetPassParam() {
  if (window.location.href.includes('resetPass')) return true;
  return false;
};
var checkForVerifyDeviceParam = exports.checkForVerifyDeviceParam = function checkForVerifyDeviceParam() {
  if (window.location.href.includes('verifyDevice')) return true;
  return false;
};
var checkForDepositConfirmationParam = exports.checkForDepositConfirmationParam = function checkForDepositConfirmationParam() {
  var href = window.location.href;
  var trustPayRedirect = href.includes('id') && href.includes('resourcePath');
  if (href.includes('txnState') || trustPayRedirect) return true;
  return false;
};
var checkForVerifyAddressParam = exports.checkForVerifyAddressParam = function checkForVerifyAddressParam() {
  if (window.location.href.includes('verifyWithdrawAddress')) return true;
  return false;
};
var homePageRoutes = exports.homePageRoutes = function homePageRoutes(pathname, HomePage) {
  return (pathname.includes('.html') || pathname === (0, _path["default"])('/')) && /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    exact: true,
    path: pathname,
    key: pathname,
    component: HomePage
  });
};